import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  padding: 64px 160px;
  justify-content: center;
  align-items: center;
  gap: 64px;
  align-self: stretch;
  background: #222;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding: 64px 16px;
  }
`;

export const Container = styled.div`
  display: flex;
  max-width: 1120px;
  justify-content: center;
  align-items: center;
  gap: 64px;
  flex: 1 0 0;
  flex-wrap: wrap;
`;

export const Left = styled.div`
  display: flex;
  max-width: 418px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    max-width: none;
  }
`;

export const Heading = styled.h2`
  font-size: 48px;
  font-weight: bold;
  color: white;
  align-self: stretch;
  margin: 0;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    font-size: 36px;
  }
`;

export const Description = styled.p`
  color: white;
  font-size: 18px;
  align-self: stretch;
  margin: 0;
`;

export const Right = styled.div`
  display: flex;
  width: 576px;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: #fff;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    width: 100%;
    max-width: 576px;
  }

  form {
    display: flex;
    padding: 48px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    flex: 1 0 0;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }

  label {
    font-size: 16px;
    font-weight: 600;
    color: #161641;
    height: 17px;

  }

  input {
    display: flex;
    padding: 8px 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #141414;
    background: #f7f5f5;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.global.colors.primary};
    }
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  align-self: stretch;
`;

export const Button = styled.button`
  margin-top: 12px;
  background-color: ${({ theme }) => theme.global.colors.primary};
  color: white;
  padding: 14px;
  font-weight: bold;
  font-size: 1rem;
  border: none;
  border-radius: 32px;
  cursor: pointer;

  &:hover {
    background-color: #00b453;
  }
`;

export const Form = styled.div`
  border-right: 1px solid #707070;
   width: 576px;
  border-radius: 20px;
  padding: 20px;
  background: #fff;

  @media ${({ theme }) => theme.global.mediaQueries.md} {
    border-right: none;
    padding: 0;
  }
`;
